import { useMemo } from "react";
import { uniqBy } from "lodash";
import { LocationInventory } from "../../../features/FloorManager/typings/location-inventory";
import { RemoteApiError } from "../useRemote/types";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";

type Params = {
  mode: string;
  /** When false, the query does not run (e.g. hide dependent UI until needed). */
  enabled?: boolean;
};

export function useRemoteFetchAdminLocations(params: Params) {
  const { enabled = true, mode } = params;
  const queryResult = useRemoteQuery<LocationInventory[], RemoteApiError>({
    queryKey: ["admin-location"],
    url: "/location",
    params: { mode },
    enabled
  });

  const data = useMemo(
    () => (queryResult.data ? uniqBy(queryResult.data, "id") : queryResult.data),
    [queryResult.data]
  );

  return { ...queryResult, data };
}
